import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Progress from '../Util/Progress';
import { useSnackbar } from 'notistack';
import RunStatus from './RunStatus';
import runsService from '../../services/runs';
import { Run as PortalRun } from '../../services/sessionModels';

type TParams = { run: string };

interface Props extends RouteComponentProps<TParams> {}

const Run: React.FunctionComponent<Props> = (props) => {
  const runId = props.match.params.run;
  const [run, setRun] = useState<PortalRun | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let active = true;
    runsService.getRun(runId).then(
      (result: PortalRun) => active && setRun(result),
      () => enqueueSnackbar('Failed to load run', { variant: 'error', autoHideDuration: 3000 })
    );
    return () => {
      active = false;
    };
  }, [runId, enqueueSnackbar]);

  if (!run) {
    return <Progress />;
  }

  return <RunStatus runid={run.id} sessionid={String(run.sessionId)} />;
};

export default withRouter(Run);
